import { NavLink } from "react-router-dom";
import { useRef } from "react";

export default function Header() {
  const navbarRef = useRef(null);
  const closeNavbar = () => {
    if(navbarRef.current.classList.contains('show')){
      navbarRef.current.classList.remove('show');
    }
  }
  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark" style={{backgroundColor: "#02474D"}}>
        <div className="container">
          <NavLink className="navbar-brand" to="/">SK's Blog</NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav" ref={navbarRef}>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                  to="/"
                  aria-current="page"
                  onClick={closeNavbar}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                  to="/post"
                  onClick={closeNavbar}
                >
                  Posts
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                  to="/admin"
                  onClick={closeNavbar}
                >
                  Admin
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" target='_blank' to="https://sathishm.tech/"
                  onClick={closeNavbar}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
